import gql from 'graphql-tag';

export const SaveApplicationInspectionFileMutation = gql`
  mutation ($applicationInspectionFile: ApplicationInspectionFileInput!, $applicationInspectionFileId: String) {
    saveApplicationInspectionFile (applicationInspectionFile: $applicationInspectionFile, applicationInspectionFileId: $applicationInspectionFileId) 
    {
      id
      _Ebb_ApplicationId
      name
      fileType
      fileTypeOptionSet
      payLoad
      submitDate
    }
  }
`;

